module.exports = __webpack_public_path__ + "img/sosty-login.1ad67419.png";